import { render, staticRenderFns } from "./date-panel-label.vue?vue&type=template&id=7ed52c3b&"
import script from "./date-panel-label.vue?vue&type=script&lang=js&"
export * from "./date-panel-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports